import endpoints, { axios } from "../config/api";

async function getUserTaskList(search: string, page: number = 1) {
  const response = await axios.get(endpoints.task.getUserTasks(search, page));
  return response.data;
}

export default getUserTaskList;
